import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ROUTE_PROFILE } from '../../../constants/routeconstants';
import Image from './Image';

const defaultImage = typeof(window) === "undefined"
    ? null // <- don't require the image on the server (it will crash - no webpack).
    : require("!!file-loader!../../../../res/images/default-avatar.png");  // file-loader = get image as path, url-loader = get image as "data:" + base64 encoded data.

// An alias for Image, which is easier to use for avatars (user-photos). Also optionally links to the users profile.
export default class Avatar extends React.Component {

    static propTypes = {
        userId: PropTypes.number.isRequired,
        size: PropTypes.string.isRequired,
        link: PropTypes.bool
    };

    static defaultProps = {
        link: true
    };

    render() {
        const { userId, size, link } = this.props;

        const imageElem = <Image src={"/api/user/"+userId+"/photo"} size={size} circle={true} srcIfNoImage={defaultImage} />;

        return link
            ? <Link to={ROUTE_PROFILE.replace(":userId", userId)} onClick={e => e.stopPropagation()}>{imageElem}</Link>
            : imageElem;
    }

}


// WEBPACK FOOTER //
// ./src/client/src/components/reusable/image/Avatar.js